import { ReaderTaskStatuses } from '@dynamika-shared/types/reader';

import { prepareUrl } from 'src/utils/routerHelpers';
import { API_URL } from './apiDictionary';
import { getClient } from './client';

export type CalculateFirstVisitScoringArgs = {
  clinicalTrialId: string;
  parentTaskId: string;
  taskId: string;
};

export type FirstVisitScoringEntry = {
  status: ReaderTaskStatuses;
  scoring: {
    comment: string | null;
  } & Record<string, unknown>;
};

/** Keyed by scoring code, e.g. `{ HAND_BONE_AGE: { status, scoring } }`. */
export type CalculateFirstVisitScoringResult = Record<
  string,
  FirstVisitScoringEntry
>;

// GET .../calculate/first/scoring — every scoring of the parent task's first
// (baseline) visit, which is not part of the current task.
export const calculateFirstVisitScoring = (
  args: CalculateFirstVisitScoringArgs
) => {
  const api = getClient(API_URL.readerParentTaskCalculateFirstVisitScoring);

  return api.get<CalculateFirstVisitScoringResult>(
    prepareUrl(API_URL.readerParentTaskCalculateFirstVisitScoring, [
      args.parentTaskId,
      args.taskId,
    ]),
    {
      headers: {
        'x-dynamika-clinical-trial-id': args.clinicalTrialId,
      },
    }
  );
};
